import React from "react";
import { Tag } from "@flixbus/honeycomb-react";
import type { ChipTagProps } from "../CompositionChip/CompositionChip.types";

const InvalidVariableTag: React.FC<ChipTagProps> = ({ label, closeProps }) => (
  <Tag display="outlined" appearance="danger" closeProps={closeProps}>
    {label}
  </Tag>
);

export default InvalidVariableTag;
